import * as React from "react";
import { SVGProps } from "react";

const BancoNacionalSimple = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={58}
    height={26}
    viewBox="0 0 58 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g transform="translate(-24, -20)" fill="currentColor">
      <path d="M53.66,39.56c1.49,0,2.35-.56,2.35-1.56v-.04c0-.92-.77-1.52-2.4-1.52h-3.75v3.13h3.8ZM52.94,33.15c1.49,0,2.33-.49,2.33-1.47v-.04c0-.92-.77-1.45-2.24-1.45h-3.19v2.99h3.1v-.02ZM45.06,26.37h9.09c2.24,0,3.8.54,4.85,1.52.7.67,1.14,1.58,1.14,2.75v.04c0,1.96-1.17,3.13-2.73,3.79,2.14.67,3.52,1.85,3.52,4.15v.04c0,2.9-2.47,4.69-6.71,4.69h-9.13v-16.99h-.02Z"/>
      <path d="M62.17,26.36h4.59l7.29,8.97v-8.97h4.87v16.99h-4.31l-7.57-9.31v9.31h-4.87v-16.99Z"/>
      <path d="M25.07,43.35l7.64-20.43,8.16-2.28-3.85,22.7h-4.71l4.94-19.42-3.24.89-6.11,18.53h-2.84Z"/>
      <path d="M41.32,25.95l-2.07,17.39h3.64l.21-14.62-1.77-2.77Z"/>
    </g>
  </svg>
);

export default BancoNacionalSimple;
